import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NSpace } from 'naive-ui';

export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComp',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NSpace), { justify: "center" }, {
    default: _withCtx(() => [
      _createTextVNode("rez@2023")
    ]),
    _: 1
  }))
}
}

})